import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import './FormGroup.scss'

const FormGroup = forwardRef((props, ref) => {
	const { children, ...other } = props

	return (
		<div ref={ref} className="form-group" {...other}>
			{children}
		</div>
	)
})

FormGroup.displayName = 'FormGroup'

export default FormGroup

FormGroup.propTypes = {
	children: PropTypes.node
}
